import { useNavigate } from "@reach/router";

import { clearLocalStorage } from "kanopi-components/utils/browser";

import { setBearer } from "kw/api";
import { useAPI } from "kw/api/useAPI";
import { useUser } from "../useUser";

const logoutMutation = {
  logoutUser: {
    success: true,
  },
};

export function useLogout() {
  const navigate = useNavigate();
  const user = useUser();
  const { mutation } = useAPI();

  const clearSession = async () => {
    await mutation(logoutMutation);
    clearLocalStorage();
    setBearer(null);
    // We avoid clearing global state as that causes a full component reload which
    // causes inconsistent behaviour (i.e. customer redirected to wrong login page)
    // TODO: We need find a better way to do these.
    // clearGlobal();
  };

  async function logout() {
    let nextUrl = "/login";

    if (user?.allowAdminPortalAccess) {
      nextUrl = "/admin/login";
    }
    await clearSession();
    navigate(nextUrl, { replace: true });
  }

  return { clearSession, logout };
}
